import { render } from "./CollectionUserDropzone.vue?vue&type=template&id=0a0451bc&scoped=true"
import script from "./CollectionUserDropzone.vue?vue&type=script&lang=js"
export * from "./CollectionUserDropzone.vue?vue&type=script&lang=js"

import "./CollectionUserDropzone.vue?vue&type=style&index=0&id=0a0451bc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0a0451bc"

export default script